import axios from "axios";

// Backend URL belirleme — iki katmanlı güvenlik:
// Katman 1: Runtime hostname kontrolü (build sistemi ne inject ederse etsin)
//   → ehliyetdersi.net'teyse her zaman production custom domain kullan
// Katman 2: .env / .env.production değeri (CRA native, ortama göre otomatik)
//   → preview: qbank-test.preview.emergentagent.com
//   → production build: ehliyetdersi.net (.env.production)
function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window !== "undefined" && window.location.hostname === "ehliyetdersi.net") {
    // Platform yanlış URL inject ettiyse uyar — bu log production'da görünürse
    // tekrar platform injection sorunu var demektir
    if (envUrl && (envUrl.includes("soru-hub") || envUrl.includes("emergent.host"))) {
      console.warn(
        "[qbank] Platform inject ettiği backend URL override edildi:",
        envUrl, "→ https://ehliyetdersi.net"
      );
    }
    return "https://ehliyetdersi.net";
  }
  return envUrl;
}

const BACKEND_URL = resolveBackendUrl();

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qbank_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("qbank_token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const BACKEND_URL_BASE = BACKEND_URL;
export default api;
